import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1040d529"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-96 container shadow-table rounded-lg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-8 border-b-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Services")
], -1))
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = { class: "px-2 py-1 bg-gray-100 rounded-2xl" }
const _hoisted_5 = { class: "flex flex-row justify-center" }
const _hoisted_6 = { class: "px-2 py-1 bg-gray-100 rounded-2xl" }
const _hoisted_7 = { class: "flex flex-row justify-center text-center" }
const _hoisted_8 = {
  key: 0,
  class: "px-2 py-1 bg-gray-100 rounded-2xl"
}
const _hoisted_9 = {
  key: 1,
  class: "px-2 py-1 bg-gray-100 rounded-2xl w-24"
}
const _hoisted_10 = { class: "flex flex-row justify-center text-center" }
const _hoisted_11 = {
  key: 0,
  class: "px-2 py-1 bg-orange-300 rounded-2xl w-24"
}
const _hoisted_12 = {
  key: 1,
  class: "px-2 py-1 bg-green-300 rounded-2xl w-24"
}
const _hoisted_13 = { class: "flex flex-row justify-center" }
const _hoisted_14 = { class: "px-2 py-1 bg-black rounded-2xl text-white uppercase" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-slot-mode": true,
        "is-static-mode": true,
        "is-hide-paging": true
      }, {
        transaction_type: _withCtx((data) => [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(data.value.transaction_type), 1)
          ])
        ]),
        created_at: _withCtx((data) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_DateFormatter, {
                date: data.value.created_at
              }, null, 8, ["date"])
            ])
          ])
        ]),
        updated_at: _withCtx((data) => [
          _createElementVNode("div", _hoisted_7, [
            (data.value.status === 'complete')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(_component_DateFormatter, {
                    date: data.value.created_at
                  }, null, 8, ["date"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
          ])
        ]),
        status: _withCtx((data) => [
          _createElementVNode("div", _hoisted_10, [
            (data.value.status === 'pending')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Pending"))
              : _createCommentVNode("", true),
            (data.value.status === 'complete')
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Paid"))
              : _createCommentVNode("", true)
          ])
        ]),
        amount: _withCtx((data) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, " $" + _toDisplayString((data.value.amount / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })) + " " + _toDisplayString(data.value.currency), 1)
          ])
        ]),
        invoice_url: _withCtx((data) => [
          _createElementVNode("a", {
            href: data.value.invoice_url,
            target: "_blank",
            class: _normalizeClass(
              data.value.invoice_url === null ? 'btn-text-disabled' : 'btn-text'
            )
          }, "View invoice", 10, _hoisted_15)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable"])
    ])
  ]))
}